<template></template>

<script>
import getLastSupervision from "@/mixins/getLastSupervision";

export default {
  mixins: [getLastSupervision],
};
</script>